<template>
  <div class="animated fadeIn">
    <b-card size="sm" footer-bg-variant="white" footer-border-variant="white">
      <div slot="header">
        <i class="icon-note"></i> Detail Pengajuan Karyawan
      </div>

      <b-card-body>
        <b-form
          id="employeeInquiryForm"
          validated
          novalidate
          @submit="editEmployee"
        >
          <div v-if="loading == false">
            <b-row>
              <b-col sm="4">
                <b-form-group label-for="division" label="Request For Division">
                  <model-select
                    id="village"
                    :options="listDivisionEmployee"
                    v-model="$v.employeeInquiryForm.division.$model"
                    :isError="$v.employeeInquiryForm.division.$invalid"
                    @input="getPosition"
                    placeholder="-- Harap pilih salah satu --"
                  ></model-select>

                  <div
                    v-if="employeeInquiryForm.division === null"
                    class="invalid-feedback-custom"
                  >
                    Divisi harus di isi.
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="4">
                <b-form-group label-for="division" label="Request For Position">
                  <model-select
                    id="village"
                    :options="listPositionEmployee"
                    v-model="$v.employeeInquiryForm.position.$model"
                    :isError="$v.employeeInquiryForm.position.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                  ></model-select>

                  <div
                    v-if="employeeInquiryForm.position === null"
                    class="invalid-feedback-custom"
                  >
                    Posisi harus di isi.
                  </div>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="4">
                <b-form-group
                  label-for="office"
                  label="Request For Head Office"
                >
                  <model-select
                    id="village"
                    :options="listEmployeeHO"
                    v-model="$v.employeeInquiryForm.office.$model"
                    :isError="$v.employeeInquiryForm.office.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                  ></model-select>

                  <div
                    v-if="employeeInquiryForm.office === null"
                    class="invalid-feedback-custom"
                  >
                    Tempat Kerja harus di isi.
                  </div>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="6">
                <b-form-group label-for="reason" label="Reason">
                  <b-form-textarea
                    id="reason"
                    :rows="3"
                    :max-rows="6"
                    v-model="$v.employeeInquiryForm.reason.$model"
                    :state="!$v.employeeInquiryForm.reason.$invalid"
                    required
                  ></b-form-textarea>
                  <b-form-invalid-feedback
                    >Alasan harus di isi.</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="4">
                <b-form-group
                  label-for="status"
                  label="Status"
                >
                  <model-select
                    id="village"
                    :options="listEmployeeStatusInquiry"
                    v-model="$v.employeeInquiryForm.status.$model"
                    :isError="$v.employeeInquiryForm.status.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                  ></model-select>

                  <div
                    v-if="employeeInquiryForm.status === null"
                    class="invalid-feedback-custom"
                  >
                    Status harus di isi.
                  </div>
                </b-form-group>
              </b-col>
            </b-row>

            <div class="text-right">
              <b-button type="button" size="sm" variant="danger" @click="back">
                <i class="fa fa-undo"></i> Back </b-button
              >&nbsp;
              <b-button
                type="submit"
                size="sm"
                variant="primary"
                :disabled="$v.employeeInquiryForm.$invalid"
              >
                <i class="fa fa-save"></i> Save
              </b-button>
            </div>
          </div>

          <div v-else>
            <loading></loading>
          </div>
        </b-form>
      </b-card-body>
    </b-card>
  </div>
</template>


<script>
import axios from "axios";
import globalTable from "../../templates/Table.vue";
import _interfaces from "@/templates/_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import * as moment from "moment";
import "moment/locale/id";
import { ModelSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";

export default {
  name: "employee_detail",
  components: {
    globalTable,
    ModelSelect,
    loading
  },
  props: {
    tableDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      authorization: 1,
      listDivisionEmployee: [],
      listPositionEmployee: [],
      listEmployeeStatusInquiry: [],
      listPosition: [],
      listEmployeeHO: [],
      loading: false,
      employeeInquiryForm: _interfaces.employee_inquiry,
    };
  },
  validations: {
    employeeInquiryForm: {
      division: { required },
      position: { required },
      office: { required },
      reason: {},
      status: {},
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function (employee_id) {
      this.loading = true;
      this.getAllEmployeeDetail(employee_id);
      this.getDropdown();
    },
    getAllEmployeeDetail: function (employee_id) {
      this.loading = true;
      this.axios
        .get("web/employee_inquiry/detail/" + employee_id + "/")
        .then((response) => {
          this.employeeInquiryForm = response.data.data;
          this.listPositionEmployee = response.data.employee_position;
        })
        .catch((error) => {
          this.expired(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getDropdown: function () {
      this.axios
        .get("web/dropdown/employee-inquiry/")
        .then((response) => {
          this.listDivisionEmployee = response.data.employee_division;
          this.listPosition = response.data.employee_position;
          this.listEmployeeHO = response.data.employee_head_office;
            this.listEmployeeStatusInquiry = response.data.employee_inquiry_status;
        })
        .catch((error) => {
          this.expired(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getPosition: function (event) {
      this.listPositionEmployee = this.listPosition.filter(
        (x) => x.division_id === event
      );
      this.employeeInquiryForm.position = null;
    },
    back: function () {
      this.$router.go(-1);
    },
    resetForm: function () {
      for (var a in _interfaces.employee_inquiry) {
        _interfaces.employee_inquiry[a] = null;
      }
      this.employeeInquiryForm = _interfaces.employee_inquiry;
    },
    editEmployee: function (evt) {
      evt.preventDefault();
      let messages = "Apakah anda ingin mengubah permintaan ini ?";
      if (confirm(messages)) {
        let employee = this.employeeInquiryForm;
        this.axios
          .put("web/employee_inquiry/change/", employee)
          .then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Ubah Karyawan",
                message: response.data.message,
              });
            }
          })
          .catch((error) => {
            this.expired(error);
          })
          .finally(() => {
            // if (employee.status === 2) {
            //   this.back();
            // } else {
              let route = this.$route.path.split("/");
              this.init(route[4]);
          //  }
          });
      }
    },
  
    expired: function (error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: "Ubah Karyawan",
          message: error.response.data.message,
        });
      }
    },
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  },
};
</script>